<template>
  <div class="row align-items-start" v-if="data.length">
    <div class="col-12 col-md-6">
      <div class="mb-5">
        <vue-c3 :handler="stackedBar" class="height-300"></vue-c3>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="mb-5">
        <vue-custom-scrollbar class="scroll-area">
          <table class="table table-bordered table-sm">
            <thead class="bg-light">
              <tr>
                <th>Exam Name</th>
                <th>Total Score</th>
                <th>Percentage</th>
                <th>Class Average</th>
                <th>Class Average %</th>
                <th>Rank</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="examMark in declaredMarks" :key="examMark.id">
                <template v-if="declaredMarks">
                  <th>{{ examMark.exam_name }}</th>
                  <td>{{ examMark.total_mark_score }} / {{ examMark.total_exam_full_mark }}</td>
                  <td>{{ examMark.mark_percentage }}</td>
                  <td>{{ examMark.class_average_mark }}</td>
                  <td>{{ examMark.class_average_mark_percentage }}</td>
                  <td>{{ examMark.rank }}</td>
                </template>
              </tr>
            </tbody>
          </table>
        </vue-custom-scrollbar>
      </div>
    </div>
  </div>
  <div v-else>
    <p class="text-muted">No exam existes for the student!</p>
  </div>
</template>
<script>
import Vue from 'vue'
import VueC3 from 'vue-c3'
import 'c3/c3.min.css'

import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'ReportExam',
  components: {
    VueC3,
    vueCustomScrollbar,
  },
  props: {
    data: {
      type: Array,
    },
  },
  data: function () {
    return {
      stackedBar: new Vue(),
      colors: {
        primary: '#01a8fe',
        def: '#acb7bf',
        success: '#46be8a',
        danger: '#fb434a',
      },
    }
  },
  computed: {
    examNames() {
      return this.data.map(element => {
        return element.exam.name
      })
    },
    stackedBarOptions() {
      let studentPCs = this.data.map(element => {
        if (element.declared_marks) {
          return element.declared_marks.mark_percentage
        }
      })
      let AveragePCs = this.data.map(element => {
        if (element.declared_marks) {
          return element.declared_marks.class_average_mark_percentage
        }
      })
      let examNames = this.data.map(element => {
        return element.exam.name
      })
      return {
        data: {
          columns: [
            ['Average', ...AveragePCs],
            ['Student Score', ...studentPCs],
          ],
          type: 'bar',
        },
        color: {
          pattern: [this.colors.primary, this.colors.success],
        },
        bar: {
          width: {
            max: 45,
          },
        },
        axis: {
          x: {
            type: 'category',
            categories: [...examNames],
            tick: {
              outer: !1,
            },
            height: 50,
          },
          y: {
            max: 100,
            tick: {
              outer: !1,
              count: 5,
              values: [0, 25, 50, 75, 100],
            },
          },
        },
        grid: {
          x: {
            show: !0,
          },
          y: {
            show: !0,
          },
        },
      }
    },
    declaredMarks() {
      return this.data.map(element => {
        if (element.declared_marks) {
          element.declared_marks.exam_name = element.exam.name
          return element.declared_marks
        }
      }).filter(element => {
        return element !== undefined
      })
    },
  },
  watch: {
    data: function(val) {
      this.stackedBar.$emit('init', this.stackedBarOptions)
    },
  },
  mounted() {
    this.stackedBar.$emit('init', this.stackedBarOptions)
  },
}
</script>
